import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jksbgl",
  "use": "icon-jksbgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-jksbgl\"><circle cx=\"10\" cy=\"9\" r=\"5.5\" stroke=\"#666768\" /><circle cx=\"10\" cy=\"6.5\" r=\".5\" fill=\"#666768\" /><circle cx=\"10\" cy=\"10\" r=\"1.5\" stroke=\"#666768\" /><path stroke=\"#666768\" stroke-linecap=\"square\" d=\"m9.139 14.693-1.446 2.168m3.168-2.168 1.446 2.169\" /><path stroke=\"#666768\" stroke-linecap=\"round\" d=\"M5.5 17.5h9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol